import React, { useState } from 'react';
import { Calculator, ChevronDown, ChevronUp } from 'lucide-react';

const EconomyPlanCalculator = ({ planPrice, planName }) => {
  const [showBreakdown, setShowBreakdown] = useState(false);
  
  // Standard installation fee spread over 6 months
  const installationFee = 1500;
  const monthlyInstallment = Math.round(installationFee / 6);
  const totalFirstSixMonths = parseInt(planPrice.replace(/[^0-9]/g, '')) + monthlyInstallment;

  return (
    <div className="mt-4 mb-4">
      <button
        onClick={() => setShowBreakdown(!showBreakdown)}
        className="w-full flex items-center justify-between p-3 bg-slate-800/50 hover:bg-slate-800 border border-slate-600 rounded-lg transition-all duration-200"
      >
        <div className="flex items-center space-x-2">
          <Calculator className="text-cyan-400" size={18} />
          <span className="text-white text-sm font-medium">Monthly Breakdown</span>
        </div>
        {showBreakdown ? (
          <ChevronUp className="text-cyan-400" size={18} />
        ) : (
          <ChevronDown className="text-cyan-400" size={18} />
        )}
      </button>

      {showBreakdown && (
        <div className="mt-3 p-4 bg-slate-800/30 border border-slate-700 rounded-lg space-y-3">
          <div className="flex items-center justify-between pb-3 border-b border-slate-700">
            <span className="text-gray-400 text-sm">Installation Fee</span>
            <span className="text-cyan-400 font-semibold">₱{installationFee.toLocaleString()}</span>
          </div>
          
          <div>
            <div className="flex items-center justify-between mb-2">
              <span className="text-white font-medium text-sm">Months 1-6:</span>
              <span className="text-cyan-400 text-xl font-bold">₱{totalFirstSixMonths.toLocaleString()}/mo</span>
            </div>
            <div className="text-xs text-gray-400 bg-slate-900/50 p-2 rounded">
              {planPrice}/mo + ₱{monthlyInstallment}/mo installation
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between mb-2">
              <span className="text-white font-medium text-sm">Month 7 onwards:</span>
              <span className="text-cyan-400 text-xl font-bold">{planPrice}/mo</span>
            </div>
            <div className="text-xs text-gray-400 bg-slate-900/50 p-2 rounded">
              Regular subscription only
            </div>
          </div>

          <div className="pt-3 border-t border-slate-700">
            <div className="text-xs text-gray-400 text-center">
              💡 No upfront payment required • Installation fee spread over 6 months
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EconomyPlanCalculator;
